import axios, {AxiosInstance} from "axios";
import config from "../config";

const to = (promise: Promise<any>) => promise.then((data) => [null, data]).catch((error) => [error]);

class Api {
    private axios: AxiosInstance;

    constructor() {
        this.axios = axios.create({
            baseURL: config.baseURL
        })

        this.axios.interceptors.request.use((config) => {
            if(config.headers) config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`

            return config
        }, (error) => error)
        this.axios.interceptors.response.use((response) => {
            if (response.status === 401) {
                localStorage.removeItem('token');

                window.dispatchEvent(new Event("storage"));
            }

            return response;
        }, (error) => {
            if (error.response.status === 401) {
                localStorage.removeItem('token');

                window.dispatchEvent(new Event("storage"));
            }

            return error;
        })
    }

    async login(username: string, password: string) {
        const [ error, response ]: any = await to(this.axios.post('/web/login', { username, password }));
        if(error) return console.error(error);

        if(response.status !== 200 && response.response.data.error) {
            return { error: response.response.data.error };
        }

        if(response.data.token) {
            return { token: response.data.token};
        }
    }

    devices(groups?: string[]) {
        return this.axios.get('/web/devices', { params: { groups: groups?.join(',') }})
    }

    groups() {
        return this.axios.get('/web/groups')
    }

    deleteGroup(name: string) {
        return this.axios.delete(`/web/groups/${name}`)
    }

    createGroup(name: string) {
        return this.axios.post(`/web/groups`, { name })
    }
}

export default new Api();